<template>
  <span class="a-player">
    <div :class="['a-player-body', (visible ? 'visible' : null)]">
      <div v-if="visible" class="a-player-main">
        <div class="a-player-main-container">
          <video :id="id" :autoplay="autoplay" :controls="controls" :width="width" :height="height" :loop="loop" :muted="muted" :poster="poster" :preload="preload">
            <source v-for="(a, b) in types" :key="b" :src="url" :type="a.type">
            <object :data="url" :width="width" :height="height">
              <embed :src="url" :width="width" :height="height">
            </object>
            <span v-if="prompt != ''">{prompt}</span>
          </video>
          <span class="close" @click="() => cancel()"><i class="el-icon-close" /></span>
        </div>
      </div>
    </div>
    <span v-if="playText != ''" @click="() => enable()" title="点击播放">{playText}</span>
    <span v-else class="play-button" @click="() => enable()" title="点击播放"><i class="el-icon-caret-right" /></span>
  </span>
</template>

<script>
export default {
  name: 'Aplayer',
  props: {
    id: { type: String, default: () => (`a-player-${Math.random().toString().substring(2)}`) },
    autoplay: { type: Boolean, default: () => true },
    controls: { type: Boolean, default: () => true },
    loop: { type: Boolean, default: () => false },
    muted: { type: Boolean, default: () => false },
    poster: { type: String, default: () => '' },
    preload: { type: String, default: () => 'auto' },
    width: { type: String, default: () => '1152' },
    height: { type: String, default: () => '648' },
    url: { type: String, default: () => '' },
    type: { type: String, default: () => 'video/mp4' },
    prompt: { type: String, default: () => '尊敬的用户, 您好! 您的浏览器不支持 HTML5 video 视频播放。' },
    playText: { type: String, default: () => '' },
  },
  data() {
    return {
      types: [
        { name: 'mp4', type: 'video/mp4' },
        { name: 'ogg', type: 'video/ogg' },
        { name: 'webm', type: 'video/webm' },
      ],
      visible: false,
    }
  },
  mounted() {
    document.addEventListener('keyup', ({ keyCode }) => keyCode == 27 && this.cancel());
  },
  methods: {
    enable() {
      this.visible = true;
      this.$emit('enable');
    },
    cancel() {
      this.visible = false;
      this.$emit('cancel');
      this.$nextTick(() => {
        document.removeEventListener('keyup', this.cancel);
      });
    }
  },
}
</script>

<style scoped>
@import "index.css";
</style>